export default {
  toasts: {
    printing: 'Tulostetaan...',
    print_failed: 'Tulostus epäonnistui. Yritä uudelleen',
    orders: {
      print_one: 'Tulostetaan {{count}} kuitti: Tilaus <strong>#{{orderNumber}}</strong>...',
      print_other: 'Tulostetaan {{count}} kuittia: Tilaus <strong>#{{orderNumber}}</strong>...',
    },
  },
};
